import { graphql } from 'react-relay';

export const performanceOverviewInfoFragment = graphql`
    fragment PerformanceOverviewInfo_data on PerformanceOverviewInfo {
        currentperformancetext
        currentbenchmarktext
        paperformancetext
        pabenchmarktext
    }
`;
